import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import { useForm, Controller } from "react-hook-form";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS, es } from "date-fns/locale";
import FeaturedVideoIcon from "@mui/icons-material/FeaturedVideo";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import HelpIcon from "@mui/icons-material/Help";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import logo from "../../_images/logos/LogoLimited.png";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment-timezone";
import Autocomplete from "@mui/material/Autocomplete";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { LifeSafer } from "../../_helpers/BrandConstants";
import { USA } from "@/_helpers/CountryConstants";
import Cookies from "universal-cookie";
import { loadStates } from "../../_redux/actions/userActions";
import { utilities } from "../../_helpers/utilities";
import { brandColors } from "../../_components/brandedComponent/BrandedColors";
import ContinueButton from "./ContinueButton";
import {
  saveEnrollee,
  clientUpdate,
} from "../../_redux/actions/enrolleeActions";
// import { useParams } from "react-router-dom";

const IdInfo = ({
  loadStates,
  statesList,
  submitting,
  goToBackStep,
  handleUpdate,
}) => {
  const cookies = new Cookies();
  const { t, i18n } = useTranslation();
  const removeNeed = useRef(false);
  const siteCountryId = cookies.get("siteCountry") || USA;
  // const countryCode = sessionStorage.getItem("LSCountryCode");
  // const locale = countryCode === "US" ? enUS : enAU;
  const locale = i18n.language === "es" ? es : enUS;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const [openDrawer, setOpenDrawer] = useState(false);
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const isBelow965 = useMediaQuery(theme.breakpoints.down(965));
  const isFirstLoad = useRef(true);
  // const { storyName } = useParams();
  // const isPartnerStory = storyName?.toLowerCase() === "partner";
  // const isPlaceholderDob = (dob) => {
  //   const raw = String(dob || "").trim();
  //   return raw.includes("0001");
  // };

  // const normalizeDob = (dob) => {
  //   if (!dob) return null;
  //   const parsed = dob instanceof Date ? dob : new Date(dob);

  //   return Number.isNaN(parsed.getTime()) ? null : parsed;
  // };

  useEffect(() => {
    loadStates(siteCountryId, brand).catch((error) => {
      console.error("Error loading states", error);
    });
  }, [siteCountryId, brand]);

  useEffect(() => {
    if (enrolleeUser) {
      if (enrolleeUser?.dlState && isFirstLoad?.current === true) {
        let matchedState = statesList.find(
          (x) => x?.shortName === enrolleeUser?.dlState,
        );
        if (matchedState) {
          setValue("state", matchedState);
          isFirstLoad.current = false;
        }
      }

      if (
        enrolleeUser?.dlNum?.toLowerCase() == "ce - need" &&
        removeNeed.current === false
      ) {
        setValue("identificationNumber", null);
        removeNeed.current = true;
      }
    }
  }, [enrolleeUser, statesList]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      state: null,
      identificationNumber:
        utilities.normalizeApiFieldValue(enrolleeUser?.dlNum) ?? null,
      dob: enrolleeUser?.dob ? new Date(enrolleeUser.dob) : null,
    },
  });

  const onSubmit = (data) => {
    let oldData = {
      EnrolleeId: enrolleeUser?.enrolleeId,
      ClientId: enrolleeUser?.clientId,
      UserId: enrolleeUser?.userId,
      firstName: enrolleeUser?.firstName,
      lastName: enrolleeUser?.lastName,
      dob: enrolleeUser?.dob,
      homeAddr1: enrolleeUser?.homeAddr1,
      homeAddr2: enrolleeUser?.homeAddr2,
      city: enrolleeUser?.city,
      zip: enrolleeUser?.zip,
      state: enrolleeUser?.state,
      county: enrolleeUser?.county,
      country: enrolleeUser?.country,
      dlState: enrolleeUser?.dlState || null,
      dlNum: enrolleeUser?.dlNum || "CE - NEED",
      dlExpirationDate: enrolleeUser?.dlExpirationDate,
      email: enrolleeUser?.email,
      homePhone: enrolleeUser?.homePhone,
      cellPhone: enrolleeUser?.cellPhone,
      workPhone: enrolleeUser?.workPhone,
      programType: enrolleeUser?.programType,
      protPlan: enrolleeUser?.protPlan,
      contractEnd: enrolleeUser?.contractEnd,
      homeLat: enrolleeUser?.homeLat,
      homeLong: enrolleeUser?.homeLong,
    };

    // const dobValue = normalizeDob(data?.dob);
    let formattedDate = data?.dob
      ? new Intl.DateTimeFormat("en-US").format(data?.dob).toString()
      : null;

    let newData = {
      Step: "Id",
      story: "Schedule Now",
      dlState: data.state.shortName || null,
      dlNum: data.identificationNumber || "CE - NEED",
      dob: formattedDate,
      enrollmentCode:
        enrolleeUser?.enrollmentCode || enrolleeUser?.EnrollmentCode,
      enrollmentCodeId:
        enrolleeUser?.enrollmentCodeId ||
        enrolleeUser?.EnrollmentCodeId ||
        enrolleeUser?.EnrollmentCodeID,
      deviceType: enrolleeUser?.deviceType,
    };

    let updatedData = {
      ...oldData,
      ...newData,
    };

    handleUpdate("Id", updatedData);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };

  const IdentificationNumber = () => (
    <Grid sx={{ position: "relative", width: "100%", maxWidth: "300px" }}>
      {isMobile && (
        <HelpIcon
          color="primary"
          sx={{
            position: "absolute",
            right: "-24px",
            top: "-19px",
          }}
          onClick={toggleDrawer(true)}
        />
      )}

      <TextField
        style={{ width: "100%", maxWidth: "300px" }}
        variant="outlined"
        id="identificationNumber"
        size="small"
        label={t("body.IDNumberLabel")}
        name="identificationNumber"
        placeholder={t("steps.identificationNumberSelect")}
        disabled={submitting}
        error={!!errors.identificationNumber}
        helperText={
          errors.identificationNumber ? errors.identificationNumber.message : ""
        }
        {...register("identificationNumber", {})}
        slotProps={{
          input: {
            startAdornment: <FeaturedVideoIcon className="inputIco" />,
          },
        }}
      />
      {/* {isPartnerStory && (
        <Typography
          sx={{ fontSize: "11px", paddingLeft: "12px", paddingTop: "4px" }}
          variant="body2"
          color="text.secondary"
        >
          {t("steps.idInfoDescription")}
        </Typography>
      )} */}
    </Grid>
  );

  return (
    <>
      <form
        className="form"
        onSubmit={handleSubmit(onSubmit)}
        style={{
          width: "100%",
          marginBottom: "40px",
          display: "flex",
          justifyContent: "center",
          maxWidth: "900px",
        }}
      >
        <Grid
          container
          alignItems="start"
          justifyContent="center"
          // direction="column"
          sx={{ minWidth: "300px", marginTop: "25px" }}
          spacing="25px"
        >
          <Grid style={{ maxWidth: "300px", width: "100%" }}>
            <Controller
              name="state"
              disableClearable
              render={({
                field: { onChange, value, ...fieldProps },
                fieldState: { error },
              }) => (
                <Autocomplete
                  {...fieldProps}
                  id="state"
                  style={{ width: "100%", maxWidth: "300px" }}
                  options={statesList}
                  disabled={submitting}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option, value) =>
                    value?.name === option?.name
                  }
                  onChange={(_, data) => {
                    onChange(data);
                  }}
                  value={value}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      {...params}
                      size="small"
                      label={t("body.stateLabel")}
                      variant="outlined"
                      placeholder={t("body.statePlaceholder")}
                      error={!!error}
                      helperText={error?.message}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              )}
              control={control}
              rules={{
                required: t("body.stateRequired"),
              }}
            />
          </Grid>

          <IdentificationNumber />

          <Grid style={{ maxWidth: "300px", width: "100%" }}>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={locale}
            >
              <Controller
                control={control}
                name="dob"
                rules={{
                  required: {
                    value: true,
                    message: t("body.dobRequired"),
                  },
                  validate: (value) => {
                    if (!value) return t("body.dobRequired");

                    const dateValue = new Date(value);
                    if (isNaN(dateValue.getTime())) {
                      return t("body.dobInvalid");
                    }

                    const minDate = moment().subtract(100, "years").toDate();
                    const maxDate = moment().subtract(14, "years").toDate();

                    if (dateValue < minDate || dateValue > maxDate) {
                      return t("body.dobInvalid");
                    }
                    return true;
                  },
                }}
                render={({ field: { onChange, value, ...fieldProps } }) => {
                  // const normalizedValue = normalizeDob(value);
                  // const hasDobValue = Boolean(normalizedValue);
                  return (
                    <DesktopDatePicker
                      {...fieldProps}
                      value={value}
                      onChange={(value) => {
                        onChange(value);
                      }}
                      disabled={submitting}
                      id="dob"
                      label={t("body.dobLabel")}
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                      }}
                      inputFormat="MM/dd/yy"
                      disableFuture
                      openTo="year"
                      views={["year", "month", "day"]}
                      slotProps={{
                        textField: {
                          error: !!errors.dob,
                          helperText: errors.dob?.message || "",
                          InputLabelProps: { shrink: true },
                          fullWidth: true,
                          size: "small",
                          placeholder: "MM/DD/YY",
                          sx: {
                            maxWidth: "300px",
                            width: "100%",
                            // "& [class*='MuiPickersInputBase-sectionsContainer']":
                            //   {
                            //     opacity: "1 !important",
                            //     color: hasDobValue ? "inherit" : "#9aa0a6",
                            //   },
                          },
                        },
                        field: {
                          clearable: true,
                        },
                      }}
                    />
                  );
                }}
              />
            </LocalizationProvider>
          </Grid>

          <ContinueButton goToBackStep={goToBackStep} submitting={submitting} />

          {!isMobile && !isMobileSmall && (
            <Grid
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                // marginTop: "30px",
              }}
            >
              <Grid sx={{ maxWidth: isBelow965 ? "300px" : "700px" }}>
                <Typography
                  sx={{
                    border: `2px solid ${brandColors[brand].primary}`,
                    borderRadius: "10px",
                    padding: "8px",
                    fontSize: "10px",
                    fontWeight: 400,
                    color: "black",
                  }}
                >
                  {t("steps.idInfoDescription")}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>

        <Drawer anchor="bottom" open={openDrawer} onClose={toggleDrawer(false)}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              borderTop: `2px solid ${brandColors[brand].primary}`,
            }}
          >
            <Box
              sx={{
                width: "100%",
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 1,
              }}
            >
              <Grid sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <img
                  src={logo}
                  alt="logo"
                  style={{
                    height: isMobileSmall ? "26px" : "18px",
                    width: isMobileSmall ? "150px" : "100px",
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: `${brandColors[brand].primary}`,
                    mt: isMobileSmall ? "8px" : "2px",
                    fontStyle: "italic",
                    fontSize: isMobileSmall ? "24px" : "20px",
                  }}
                >
                  {t("steps.stateId")}
                </Typography>
              </Grid>
              <IconButton
                sx={{
                  position: "absolute",
                  right: isMobileSmall ? "20px" : "0px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "red",
                }}
              >
                <CloseIcon
                  sx={{
                    fontSize: "18px",
                  }}
                  onClick={toggleDrawer(false)}
                />
              </IconButton>
            </Box>
          </Box>
          <Grid>
            <Box sx={{ display: "flex", width: "100%", pb: 2, px: 1 }}>
              {t("steps.idInfoDescription")}
            </Box>
          </Grid>
        </Drawer>
      </form>
    </>
  );
};

function mapStateToProps(state) {
  return {
    statesList: state.statesList,
  };
}

const mapDispatchToProps = {
  loadStates,
  saveEnrollee,
  clientUpdate,
};

IdInfo.propTypes = {
  statesList: PropTypes.object,
  loadStates: PropTypes.func,
  goToBackStep: PropTypes.func,
  saveEnrollee: PropTypes.func,
  clientUpdate: PropTypes.func,
  submitting: PropTypes.bool,
  handleUpdate: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdInfo);
